import { render } from "./FriendsNpc1.vue?vue&type=template&id=b5fa3536&scoped=true"
import script from "./FriendsNpc1.vue?vue&type=script&lang=js"
export * from "./FriendsNpc1.vue?vue&type=script&lang=js"

import "./FriendsNpc1.vue?vue&type=style&index=0&id=b5fa3536&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5fa3536"]])

export default __exports__